module.exports = __webpack_public_path__ + "img/1552835709.9c851a8c.jpg";